import React, { Component } from "react";

import CuentaSocioTransferencia from "../../generico/CuentaSocioTransferencia";
import DataTable from "react-data-table-component";
import { trackPromise } from "react-promise-tracker";
import RuedaService from "../../../services/rueda/RuedaService";
import RuedasService from "../../../services/rueda/RuedaService";
import { formatoSeparadorMilesValue } from "../../generico/utils/FormatoInput";
import $ from "jquery";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";
import Popup from "react-popup";


const paginationOptions = {
  rangeSeparatorText: "de",
  noRowsPerPage: true
};

const DetalleFila = ({ data }) => (
  <div className="row" style={{ margin: 0 }}>
    <div className="col-md-2">
      <p style={{ fontWeight: 500 }}>Detalles:</p>
    </div>
    <div className="col-md-2">
      <p>{data.cantSocio} Socios</p>
    </div>
    <div className="col-md-3">
      <p>
        {data.cantCuota} Cuotas de {data.importeCuota}
      </p>
    </div>
    <div className="col-md-2">
      <p>Estado: {data.estado}</p>
    </div>
  </div>
);

export default class Rueda1 extends Component {
  TIPO_DEBITO = "D";
  TIPO_CREDITO = "C";

  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }
  initData = () => {

    this.resetState();
    this.getCuentas(this.TIPO_DEBITO);
    this.obtenerGruposRueda();
    this.continuar.disabled = true;
  };

  resetState = () => {
    this.setState(this.getInitialState());
    this.grupoSel = undefined;
  };

  getInitialState = () => ({
    cuentasOrigen: [],
    listaPlan: [],
    ruedasList: [],
    ctaOrigenSele: { value: "-1", label: "--Seleccione--" },
    ctaFullData: {}

  });

  componentDidMount() {
    this.initData();
  }

  getListaPlan() {
    var respuesta = [];

    var items = this.state.ruedasList === null ? [] : this.state.ruedasList.resultadosDetalles;
    if (items !== null) {
      for (var i = 0; i < items.length; i++) {
        respuesta.push({
          id: items[i].grupo,
          plan: items[i].plan,
          cantSocio: formatoSeparadorMilesValue(items[i].cantidadSocio),
          totalContratos: items[i].cantidadSocio,
          cantCuota: items[i].cantidadCuota,
          importeCuota:
            formatoSeparadorMilesValue(items[i].importeCuota) + " GS.",
          estado: items[i].estado === "2" ? "FORMACIÓN" : "-",
          adquisicion: formatoSeparadorMilesValue(items[i].montoAdjudicacion) + " GS.",
          fechaInicio: items[i].fechaInicio,
          fechaModulo: this.state.ruedasList.primerVencimiento,
          fechaVencimiento: this.state.ruedasList.fechaVencimiento,
          importeTotalDebito:
            formatoSeparadorMilesValue(items[i].importeTotal) + " GS.",
          atributoContratoRuedaDet: this.state.ruedasList.resultadosContratos !== null ? this.state.ruedasList.resultadosContratos.filter(c => c.grupo === items[i].grupo) : console.log("nada")

        });
      }
    }

    this.setState({ listaPlan: respuesta });
    return this.state.listaPlan;
  }

  getCuentas(tipo) {
    trackPromise(
      RuedaService.getCuentas(tipo).then((response) => {
        var data = JSON.stringify(response.data);
        var jsonData = JSON.parse(data);
        if (tipo === this.TIPO_DEBITO) {
          this.setState({ cuentasOrigen: jsonData.resultadoAH });
        } else if (tipo === this.TIPO_CREDITO) {
          this.setState({ cuentasDestino: jsonData.resultadoAH });
        }
      })
    );
  }

  obtenerGruposRueda(tipo) {
    trackPromise(
      RuedasService.obtenerGruposRueda(tipo).then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);
        console.log("jData: ", jData);
        if (jData.codigo !== '0') {
          Popup.queue(this.notifiPopup("¡ATENCIÓN!", jData.mensaje));
        } else {
          this.setState(
            { ruedasList: jData },
            this.getListaPlan
          );
        }

      })
    );
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    })

  selGrupoEvt = (e) => {
    this.grupoSel = e.currentTarget;
    this.enableNext();
  };

  enableNext() {
    const { ctaOrigenSele } = this.state;
    if (
      ctaOrigenSele.value !== undefined &&
      ctaOrigenSele.value !== "-1" &&
      this.grupoSel !== undefined
    ) {
      this.continuar.disabled = false;
    } else {
      this.continuar.disabled = true;
    }
    this.checkGrilla();
  }

  checkGrilla() {
    if (this.grupoSel !== undefined) {
      $("#" + this.grupoSel.id).prop("checked", true);
    }
  }

  getColumn() {
    return [
      {
        cell: (row) => (
          <input
            ref={() => this.grupoSel}
            id={"radio_" + row.id}
            type="radio"
            key={row.id}
            name="rowRadio"
            value={row.id}
            onClick={this.selGrupoEvt}
          ></input>
        ),
        width: "50px",
      },
      {
        name: "Plan",
        selector: row => row.plan,
      },
      {
        name: "Cant. de Socios",
        selector: row => row.cantSocio,
        omit: true,
      },
      {
        name: "Cant. de Cuotas",
        selector: row => row.cantCuota,
        omit: true,
      },
      {
        name: "Importe de Cuotas",
        selector: row => row.importeCuota,
        omit: true,
      },
      {
        name: "Estado",
        selector: row => row.estado,
        omit: true,
      },
      {
        name: "Adquisición",
        selector: row => row.adquisicion,
      },
      {
        name: "Fecha de Inicio",
        selector: row => row.fechaInicio,
      },
    ];
  }
  cuentaOrigenReturn = (ctaFullData, item) => {

    this.setState(
      {
        ctaFullData: ctaFullData,
        ctaOrigenSele: item,
      },
      this.enableNext
    );
  };
  getDatosCuentaDestino(array, id) {

    var foundItems = $.grep(array, function (v) {
      return v.id.toString() === id.toString();
    });
    return foundItems;
  }

  seleccionarFila(row) {
    //pintarFilaSeleccionada("row-" + row.id)
    /// control de radio button
    var radio = document.getElementById("radio_" + row.id)
    radio.checked = true
    radio.click(this.selGrupoEvt);
  }

  render() {
    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="current">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Selección de Plan
                    </span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Número de Contrato</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Datos de Verificación</span>
                  </div>
                </span>
              </li>
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
              <div className="col-md-5">
                <CuentaSocioTransferencia
                  selectorValue={this.cuentaOrigenReturn.bind(this)}
                  operacion="DEBITO"
                  tipoCuenta="AHORRO_VISTA"
                  items={this.state.cuentasOrigen}
                  itemSelected={this.state.ctaOrigenSele}
                />
              </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12" id="rueda-adquision">
            <label className="input-label-bold">Seleccione el Plan *</label>
            <DataTable
              noHeader={true}
              pagination={true}
              columns={this.getColumn()}
              data={this.state.listaPlan}
              dense={true}
              paginationComponentOptions={paginationOptions}
              noDataComponent="No hay ruedas disponibles"
              responsive={true}
              striped={true}
              expandableRowsComponent={
                DetalleFila
              }
              onRowClicked={(e) => this.seleccionarFila(e)}
              expandableRows
              pointerOnHover
            />
          </div>
        </div>

        <hr />

        <div className="row">
          <div className="col-lg-10 col-md-8">
              <label
                className="input-label-bold-obligatorio">
                (*) Campos Obligatorios
                <br />
              </label>
          </div>
          <div className="col-lg-2 col-md-3">
              <button
                ref={(button) => (this.continuar = button)}
                className="btn btn-cu-primary"
                onClick={() => {
                  var grupo = this.getDatosCuentaDestino(
                    this.state.listaPlan,
                    this.grupoSel.value
                  );
                  this.props.returnDataPaso1(this.state.ctaOrigenSele, grupo, this.state.ctaFullData);
                  this.nextStep.click();
                }}>
                Continuar <FontAwesomeIcon icon={faArrowRight} />
              </button>
              <button hidden ref={(a) => (this.nextStep = a)} className="btn btn-cu-primary" onClick={this.props.nextStep} />
          </div>
        </div>
      </div>
    );
  }
}
